import { fetchApi } from '@/config/axiosSetting';
import { GetCulpritAdjusterImagesTabsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritAdjusterImagesTabs/getCulpritAdjusterImagesTabs.type';
import { GetDamagedAdjusterImagesTabsQueryResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImagesTabs/getDamagedAdjusterImagesTabs.type';

export const getCulpritAdjusterImagesTabsQueryFunction = (
  params: GetCulpritAdjusterImagesTabsQueryParamsType,
): Promise<GetDamagedAdjusterImagesTabsQueryResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/images/adjuster/entry_tabs/`,
  );
};
